var _rect, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 112,
    rx: 16,
    fill: "url(#paint0_linear_128_11340)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 82.6663C49.8222 81.1108 44.7222 77.5663 40.7 72.033C36.6778 66.4997 34.6667 60.3552 34.6667 53.5997V37.333L56 29.333L77.3333 37.333V53.5997C77.3333 60.3552 75.3222 66.4997 71.3 72.033C67.2778 77.5663 62.1778 81.1108 56 82.6663ZM56 77.0663C60.3111 75.733 63.9111 73.0997 66.8 69.1663C69.6889 65.233 71.3778 60.8441 71.8667 55.9997H56V34.9997L40 40.9997V54.7997C40 55.1108 40.0444 55.5108 40.1333 55.9997H56V77.0663Z",
    fill: "#FF9800"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_128_11340",
    x1: 56,
    y1: 0,
    x2: 56,
    y2: 112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}

export default __webpack_public_path__ + "media/105ef053.svg";
export { SvgShield as ReactComponent };